$(document).on("keyup", ".client-name", function(){
  $.ajax({
    type: "GET",
    url: "http://localhost:3000/companies?name_like=" + $(this).val(),
    success: function(results) {
      let names = results.map(result => result.name)
      $(".client-name").autocomplete({source: names})
    },
    error: function(data) {
       alert("クライアントの取得に失敗しました。");
    }
  });
})
